const Rings = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_6304_3616)">
        <path
          d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 9.20035e-08 18.6274 9.20035e-08 12C9.20035e-08 5.37258 5.37258 9.20032e-08 12 9.20032e-08C18.6274 9.20032e-08 24 5.37258 24 12Z"
          fill="#5776FC"
        />
        <path
          d="M21.8001 5.07486C20.8907 3.78789 19.7367 2.69265 18.404 1.85166C17.0713 1.01068 15.586 0.44042 14.0329 0.173453C12.4798 -0.0935146 10.8894 -0.051965 9.35235 0.295729C7.81532 0.643423 6.36183 1.29045 5.07486 2.19988C3.78789 3.1093 2.69265 4.2633 1.85166 5.596C1.01068 6.9287 0.44042 8.41399 0.173452 9.96708C-0.0935147 11.5202 -0.0519649 13.1106 0.295729 14.6476C0.643424 16.1847 1.29045 17.6382 2.19988 18.9251L21.8001 5.07486Z"
          fill="#9FABFD"
        />
        <path
          d="M21.3334 12.0003C21.3334 17.155 17.1547 21.3337 12.0001 21.3337C6.84542 21.3337 2.66675 17.155 2.66675 12.0003C2.66675 6.84567 6.84542 2.66699 12.0001 2.66699C17.1547 2.66699 21.3334 6.84567 21.3334 12.0003Z"
          fill="#FEFBF9"
        />
        <path
          d="M4.38049 17.3904C5.08833 18.391 5.98632 19.2424 7.0232 19.896C8.06007 20.5496 9.21553 20.9925 10.4236 21.1996C11.6316 21.4066 12.8687 21.3736 14.064 21.1026C15.2593 20.8316 16.3895 20.3277 17.3902 19.6199C18.3908 18.9121 19.2422 18.0141 19.8958 16.9772C20.5493 15.9403 20.9923 14.7849 21.1993 13.5768C21.4063 12.3688 21.3734 11.1318 21.1024 9.93642C20.8313 8.7411 20.3275 7.61086 19.6197 6.61024L4.38049 17.3904Z"
          fill="#EBE4DC"
        />
        <path
          d="M18.6673 11.9997C18.6673 15.6816 15.6825 18.6663 12.0007 18.6663C8.31875 18.6663 5.33398 15.6816 5.33398 11.9997C5.33398 8.31778 8.31875 5.33301 12.0007 5.33301C15.6825 5.33301 18.6673 8.31778 18.6673 11.9997Z"
          fill="#5776FC"
        />
        <path
          d="M17.4452 8.15238C16.9399 7.43739 16.2988 6.82892 15.5584 6.36171C14.818 5.89449 13.9929 5.57769 13.1301 5.42937C12.2672 5.28106 11.3836 5.30414 10.5297 5.4973C9.67583 5.69047 8.86834 6.04993 8.15335 6.55516C7.43837 7.0604 6.8299 7.70151 6.36268 8.4419C5.89547 9.18229 5.57866 10.0074 5.43035 10.8703C5.28203 11.7331 5.30511 12.6167 5.49828 13.4706C5.69144 14.3245 6.0509 15.132 6.55614 15.847L17.4452 8.15238Z"
          fill="#9FABFD"
        />
        <path
          d="M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z"
          fill="#FEFBF9"
        />
        <path
          d="M8.73584 14.3122C9.03947 14.7408 9.42455 15.1055 9.8691 15.3853C10.3137 15.6651 10.809 15.8546 11.3268 15.943C11.8446 16.0314 12.3747 16.017 12.8869 15.9005C13.3991 15.784 13.8834 15.5678 14.312 15.2642C14.7407 14.9605 15.1053 14.5755 15.3851 14.1309C15.6649 13.6863 15.8545 13.191 15.9429 12.6732C16.0313 12.1554 16.0168 11.6253 15.9003 11.1131C15.7839 10.6009 15.5676 10.1166 15.264 9.68799L8.73584 14.3122Z"
          fill="#EBE4DC"
        />
      </g>
      <defs>
        <clipPath id="clip0_6304_3616">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Rings;
